import React, { createContext, useContext, useMemo, useState } from 'react';

const GlobalNotificationUiContext = createContext({
  isBellVisible: false,
  setBellVisible: () => {},
});

export const GlobalNotificationUiProvider = ({ children }) => {
  const [isBellVisible, setBellVisible] = useState(false);

  const value = useMemo(
    () => ({
      isBellVisible,
      setBellVisible,
    }),
    [isBellVisible],
  );

  return (
    <GlobalNotificationUiContext.Provider value={value}>
      {children}
    </GlobalNotificationUiContext.Provider>
  );
};

export const useGlobalNotificationUi = () => useContext(GlobalNotificationUiContext);
